<template>
   <div class='Draft'>

       <div v-if="loading">
            <div class="d-flex justify-content-center mt-5">
                <div class="spinner-border" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
            </div>
        </div>

        <div v-else>
            <div v-if="projectos == null">
                <div class="row pt-3">
                    <div class="col">
                        <div class="card">
                            <p class="text-center pt-2">Sin Proyectos</p>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else>
                <!-- Tabla -->
                <table class="table">
                <thead>
                    <tr>
                        <th scope="col" style="width: 25%">Nombre Proyecto</th>
                        <th scope="col">Producto</th>
                        <th scope="col">Version</th>
                        <th scope="col">Fecha Creación</th>
                        <th scope="col">Fecha Inicio</th>
                        <th scope="col">Fecha Entrega</th>
                        <th scope="col">Editar</th>
                        <th scope="col" class="text-center">Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="f in projectos" :key="f.id">
                        <td>
                            <router-link :to="{ name: 'DetalleProyecto', params: { idEmpresa: f.id_proyecto}}">
                                {{f.titulo_proyecto}}
                                <span v-if="f.asignadaA != 0">
                                    <small class="text-success">(Adjudicado)</small>
                                </span>
                            </router-link>
                        </td>
                        <td>{{f.producto}}</td>
                        <td>{{f.version}}</td>
                        <td>{{fechaFormat(f.fecha)}}</td>
                        <td>{{fechaFormat(f.fecha_inicio)}}</td>
                        <td>{{fechaFormat(f.fecha_cierre)}}</td>
                        <td>
                            <button class="btn btn-sm btn-primary" @click="editar(f.id_proyecto)">
                                <font-icon icon="edit"/>
                            </button>
                        </td>
                        <!--Publicar, Borrar, Editar-->
                        <td class="text-center">
                            <button class="btn btn-sm btn-success" :disabled="f.fecha_valida < 5"  v-if="f.estatus_proyecto == 1 || f.estatus_proyecto ==6" @click="publicar(f)" data-toggle="tooltip" data-placement="top" title="Publicar Proyecto">
                                <font-icon icon="play"/>
                            </button>
                            <!--<BotonCacelar :id="f.id_proyecto" @update="getData"/>-->
                            <button class="btn btn-sm btn-danger" @click="borrar(f.id_proyecto)" data-toggle="tooltip" data-placement="top" title="Borrar Proyecto">
                                <font-icon icon="trash-alt"/>
                            </button>
                            <br>
                            <span class="text-danger" v-if="f.fecha_valida < 5">
                                Fuera de fecha
                            </span>
                        </td>
                    </tr>
                </tbody>
                </table>
            </div>
        </div>

   </div>
</template>


<script>
import { mapState } from 'vuex'
import { globalFunctions } from '@/hooks/globalFunctions'

export default {
name: 'Draft',
mixins: [ globalFunctions ],
data () {
    return {
        projectos: [],
        loading: true
    }
},
methods: {
    getData(){
        let data = {
            id: localStorage.userID,
            flag: 0,
            prop: 1
        };

        this.axios.post(this.url + 'getProyectos.php',data).then((responce) =>{
            this.projectos = responce.data;
            this.loading = false;
            this.$emit("update");
        });
    },
    editar(id){
        this.$router.push({ name: 'EditarProyecto', params: {idProyecto:id}});
    },
    publicar(f){

        let data = {
            flag:0,
            num:2, //status
            id:f.id_proyecto
        };

        this.axios.post(this.url + 'postProyectos.php', data).then((responce) =>{
            if(responce.data == 200){
                this.enviarCorreo(2, 'Nuevo proyecto publicado', f.id_proyecto);
                this.msjOk("Proyecto Publicado");
                this.getData();
                this.$emit("update");
            }
        });
    },
    borrar(id){
        this.$swal.fire({
            title: '¿Estas Seguro?',
            text: "Ya no podras revertir el cambio",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, borrar proyecto!'
        }).then((result) => {
            if (result.isConfirmed) {
                let data = {
                    flag:5,
                    id //id proyecto
                };

                this.axios.post(this.url + 'postProyectos.php', data).then((responce) =>{
                    if(responce.data == 200){
                        this.$swal.fire(
                            'Eliminado!',
                            'Tu proyecto ha sido eliminado.',
                            'success'
                        );
                        this.getData();
                    }
                });
            }
        })
    }
},
computed:{
    ...mapState(['url'])
},
mounted(){
    this.getData();
}
}
</script>


<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/Proyectos/components/Empresa/Draft.vue